const INCLUDE_PROPERTIES =
    'TicketType,Priority,CustomerContact,Customer,Assignee';

export const TICKET_PARAMS = {
    includeProperties: INCLUDE_PROPERTIES,
};
